export default __webpack_public_path__ + "static/media/thumbnail.c9865be5.png";